import _ from 'lodash';
import classNames from 'classnames';
import React from 'react';
import * as styles from './Emoji.module.scss';

const getScale = _.memoize((className: string) => {
  const emojiSpan = document.createElement('span');
  emojiSpan.innerHTML = '😄';
  const span = document.createElement('span');
  span.appendChild(emojiSpan);
  span.className = className;
  span.style.opacity = '0';
  span.style.pointerEvents = 'none';
  span.style.position = 'fixed';
  span.style.top = '0';
  span.style.left = '0';
  document.body.appendChild(span);
  const { height, width } = emojiSpan.getBoundingClientRect();
  document.body.removeChild(span);
  return Math.ceil((height / width) * 10) / 10;
});

interface EmojiProps {
  char: string;
  size?: 'small' | 'regular' | 'large' | 'medium';
}

const Emoji = ({ char, size = 'regular' }: EmojiProps) => {
  const className = classNames(styles.char, {
    [styles.small]: size === 'small',
    [styles.large]: size === 'large',
    [styles.medium]: size === 'medium',
  });

  const scale = getScale(className);
  return (
    <span
      className={className}
      style={Number.isNaN(scale) ? undefined : { transform: `scale(${scale})` }}
    >
      {char}
    </span>
  );
};

export default Emoji;
